var Icon, m;

m = require('mithril');

Icon = require('./Icon');

module.exports = {
  view: function(ctrl, args) {
    var ref, ref1;
    return m('.PhotoNavBar', [
      m('.PhotoNavBar__prev', {
        onclick: args.prev != null ? (ref = args.prev) != null ? ref.onclick : void 0 : void 0,
        "class": args.prev != null ? 'PhotoNavBar__prev--link' : void 0
      }, Icon.left()), m('.PhotoNavBar__curr', args.current.label), m('.PhotoNavBar__next', {
        onclick: args.next != null ? (ref1 = args.next) != null ? ref1.onclick : void 0 : void 0,
        "class": args.next != null ? 'PhotoNavBar__next--link' : void 0
      }, Icon.right())
    ]);
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvdWkvY29tcG9uZW50cy9QaG90b05hdkJhci5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvYXBwL3NyYy91aS9jb21wb25lbnRzL1Bob3RvTmF2QmFyLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLENBQUEsR0FBSSxPQUFBLENBQVEsU0FBUjs7QUFFSixJQUFBLEdBQU8sT0FBQSxDQUFRLFFBQVI7O0FBRVAsTUFBTSxDQUFDLE9BQVAsR0FBaUI7RUFDaEIsSUFBQSxFQUFNLFNBQUMsSUFBRCxFQUFPLElBQVA7QUFDTCxRQUFBO1dBQUEsQ0FBQSxDQUFFLGNBQUYsRUFBa0I7TUFDakIsQ0FBQSxDQUFFLG9CQUFGLEVBQXdCO1FBQ3ZCLE9BQUEsRUFBK0IsaUJBQXRCLGtDQUFTLENBQUUsZ0JBQVgsR0FBQSxNQURjO1FBRXZCLENBQUEsS0FBQSxDQUFBLEVBQW9DLGlCQUE3QixHQUFBLHlCQUFBLEdBQUEsTUFGZ0I7T0FBeEIsRUFHRyxJQUFJLENBQUMsSUFBTCxDQUFBLENBSEgsQ0FEaUIsRUFLakIsQ0FBQSxDQUFFLG9CQUFGLEVBQXdCLElBQUksQ0FBQyxPQUFPLENBQUMsS0FBckMsQ0FMaUIsRUFNakIsQ0FBQSxDQUFFLG9CQUFGLEVBQXdCO1FBQ3ZCLE9BQUEsRUFBK0IsaUJBQXRCLG9DQUFTLENBQUUsZ0JBQVgsR0FBQSxNQURjO1FBRXZCLENBQUEsS0FBQSxDQUFBLEVBQW9DLGlCQUE3QixHQUFBLHlCQUFBLEdBQUEsTUFGZ0I7T0FBeEIsRUFHRyxJQUFJLENBQUMsS0FBTCxDQUFBLENBSEgsQ0FOaUI7S0FBbEI7RUFESyxDQURVIn0=
